export const ScrollPinnedSections = () => {
    return (
        <section id="scroll-pinned-sections">
            <h2>Teamwork solutions for the world&apos;s best teams</h2>
            <hr />
        </section>
    );
};
